import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";
import ManyMona from "@/pages/home/components/ManyMona";
import ProjectNav from "@/components/feature/ProjectNav";

export default function ManyMonaPage() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <ManyMona />
        <ProjectNav
          prev={{ label: "Re:Naissance", to: "/renaissance" }}
          next={{ label: "Mmnto.Mori", to: "/mmnto-mori" }}
        />
      </main>
      <Footer />
    </div>
  );
}